<template>
  <highlight-card
    :button="{ external: true, href: url, label: texts.familyFlowersCta }"
    :fact="{ icon: 'customFlower', text: texts.familyFlowersFact }"
    :heading="texts.familyFlowersHeading"
    :image="image ? { ...image, cover: true } : null"
    :text="texts.familyFlowersText"
  />
</template>

<script lang="ts" setup>
  import type { CardPhoto } from "../../../highlights/cards";
  import { highlightTexts } from "../../../highlights/texts";
  import HighlightCard from "../HighlightCard.vue";

  /** Flowers to the family via the market's partner, once our shop has closed. */
  defineProps<{ image?: CardPhoto; url: string }>();

  const texts = highlightTexts();
</script>
